import React from 'react';
import { Handle, Position } from 'reactflow';
import { Volume2 } from 'lucide-react';

const AudioNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-pink-200 node-audio">
      <div className="flex items-center">
        <Volume2 className="w-4 h-4 text-pink-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-pink-800">Text to Speech</div>
          <div className="text-sm text-gray-600">
            {data.config?.language || 'English'} audio
          </div>
          <div className="text-xs text-pink-600">
            Voice: {data.config?.voice || 'default'}
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-pink-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-pink-500 border-2 border-white"
      />
    </div>
  );
};

export default AudioNode;